import React from "react";
import { Navigate } from "react-router";
import PathConstants from "./PathConstantsMain"

//RedirectTo404
const RedirectTo404 = () => {
	return <Navigate to="/404" replace />;
}
//RedirectToAdmin
const RedirectToAdmin = () => {
	window.location.replace("./admin/");
	return null;
}

const Start = React.lazy(() => import("@pages/main/Start"))
const Beschwerde = React.lazy(() => import("@pages/main/Beschwerde"))
const Ablauf = React.lazy(() => import("@pages/main/Ablauf"))
const Angebot = React.lazy(() => import("@pages/main/Angebot"))
const Bearbeitungsstand = React.lazy(() => import("@pages/main/Bearbeitungsstand"))
const Ueber_uns = React.lazy(() => import("@pages/main/Ueber_uns"))
const Kontakt = React.lazy(() => import("@pages/main/Kontakt"))
const Impressum = React.lazy(() => import("@pages/main/Impressum"))
const Datenschutz = React.lazy(() => import("@pages/main/Datenschutz"))

const NotFound = () => (
  <section id="start-hinweis" class="bg-contrast right-cut-top">
    <div class="container">
      <div class="col-12">
        <h1>404 - Seite nicht gefunden</h1>
        <p>Diese Seite existiert leider nicht.</p>
      </div>
    </div>
  </section>
);

const mainRoutes = [
    { path: PathConstants.START, component: Start },
    { path: PathConstants.BESCHWERDE, component: Beschwerde },
    { path: PathConstants.ABLAUF, component: Ablauf },
    { path: PathConstants.ANGEBOT, component: Angebot },
    { path: PathConstants.BEARBEITUNGSSTAND, component: Bearbeitungsstand },
    { path: PathConstants.UEBER_UNS, component: Ueber_uns },
    { path: PathConstants.KONTAKT, component: Kontakt },
    { path: PathConstants.IMPRESSUM, component: Impressum },
    { path: PathConstants.DATENSCHUTZ, component: Datenschutz },
    { path: "/admin", component: RedirectToAdmin },
    { path: "/404", component: NotFound },
    { path: "*", component: RedirectTo404 }
];

export { mainRoutes };
